class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay')?.addEventListener('click', this.close.bind(this)); // SE MODIFICÓ
    this.setHeaderCartIconAccessibility();    

    // CONFIGURACIÓN DE PRODUCTO GRATIS
    // this.PRODUCT_ID = 15140691771763;
    // this.PRODUCT_SKU = "9881157614538";
    // this.VARIANT_PRODUCT_ID = 52801934328179;
    // this.FREE_PRODUCT_QUANTITY = 1;
    // this.PRICE_CONDITION = 450000; 

    // this.PRODUCT_ID = 15109380702579;
    // this.VARIANT_PRODUCT_ID = 52677726208371;
    this.isValidatingFreeProduct = false;

       this.FREE_PRODUCTS_CONFIG = [
  {
    productId: 15305752379763,
    sku: "9881157628740",
    variantId: 62593787036019,
    quantity: 1,
    priceCondition: 600000
  }
  // ,
  // {
  //   productId: 15264157368691, // segundo producto
  //   sku: "9881157620553",
  //   variantId: 62419783975283,
  //   quantity: 1,
  //   priceCondition: 550000
  // }
];
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink);
      this.validateFreeProduct(); //metodo producto gratis     
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }


  async validateFreeProduct() {
    // Si ya se está ejecutando, salir inmediatamente
    if (this.isValidatingFreeProduct) {
      console.log('Validación ya en proceso, omitiendo...');
      return;
    }

    // Bloquear nuevas ejecuciones
    this.isValidatingFreeProduct = true;
  try {
    let currentCart = await fetch("/cart.json");
    currentCart = await currentCart.json();

    if (!currentCart) return;

    const totalPrice = currentCart.total_price / 100;

    for (const config of this.FREE_PRODUCTS_CONFIG) {
      const isInCart = currentCart.items.some(item =>
        item.product_id === config.productId || item.sku === config.sku
      );

      // Si el monto es suficiente y el producto aún no está en el carrito
      if (totalPrice >= config.priceCondition && !isInCart) {
        console.log(`Agregando producto con condición de $${config.priceCondition}`);

        const formData = {
          items: [{
            id: config.variantId,
            quantity: config.quantity
          }],
          sections: "cart-drawer,cart-icon-bubble"
        };

        let dataResult = await fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(formData)
        }).then(res => res.json());

        if (dataResult?.items?.[0]?.id === config.variantId) {
          this.renderContents(dataResult);
        }

      // Si ya no cumple el monto mínimo y el producto está en el carrito, lo elimina
      } else if (totalPrice < config.priceCondition && isInCart) {
        console.log("elimandoooooooprimero");
        const linePosition = currentCart.items.findIndex(item => item.id === config.variantId);

        const updates = {
          line: `${linePosition + 1}`,
          quantity: "0",
          sections: ["cart-drawer", "cart-icon-bubble"],
          sections_url: "/"
        };

        console.log(`Eliminando producto por no cumplir con $${config.priceCondition}`);
        this.removeItemDrawer(updates);
      }
    }

  } catch (error) {
    console.error('Hubo un error en la validación del producto gratis:', error);
  }
  finally {
      // Desbloquear después de completar (éxito o error)
      this.isValidatingFreeProduct = false;
    }
}

  // BACKUP 
  // async validateFreeProduct (){
  //   try {
  //     let currentCart = await fetch("/cart.json");
  //     currentCart = await currentCart.json();
  
  //     let dataResult;       
      
  //     if(currentCart){  

  //       const result = currentCart.items.filter((item) => item.product_id === this.PRODUCT_ID || item.sku === this.PRODUCT_SKU);
  //       console.log('¿Hay producto gratis en el carrito? 0 → NO, 1 → SI: ', result.length);      
        
  //       if((currentCart.total_price/100) >= this.PRICE_CONDITION && result.length === 0){
  //         console.log('El producto no se encontraba en el carrito...');          
              
  //         let formData = {
  //           'items': [{
  //             'id': this.VARIANT_PRODUCT_ID, // ID de la variante del producto, pero no es product_id.
  //             'quantity': this.FREE_PRODUCT_QUANTITY
  //             }],
  //             sections: "cart-drawer,cart-icon-bubble",
  //         };
  
  //         console.log('Ejecutando la petición...');

  //         await fetch('/cart/add.js', {
  //           method: 'POST',
  //           headers: {
  //             'Content-Type': 'application/json'
  //           },
  //           body: JSON.stringify(formData)
  //         })
  //         .then(response => {
  //           return response.json();
  //         })
  //         .then(data => { 
  //             dataResult = data;          
  //           })
  //         .catch((error) => {
  //           console.error('Error:', error);
  //         })
  //         .finally(async ()=> {
  //           if(dataResult.items[0].id === this.VARIANT_PRODUCT_ID){           
  //               this.renderContents(dataResult);
  //            }          
  //         });       
  //       } else if ((currentCart.total_price/100) < this.PRICE_CONDITION && result.length === 1){
  
  //         const linePosition = currentCart.items.findIndex(item => item.id === this.VARIANT_PRODUCT_ID);
          
  //          const updates = {
  //           'line': `${linePosition + 1}`, 
  //           'quantity': "0", 
  //           'sections': ["cart-drawer", "cart-icon-bubble"], 
  //           'sections_url': "/"
  //         }

  //         this.removeItemDrawer(updates);
  
  //       }    
  //     }
  //   } catch (error) {
  //     console.error('Hubo un error en la petición:', error);
  //     throw error; // Lanza el error para manejarlo en el lugar donde se llama a fetchData
  //   }
  
  // } 

//   async validateFreeProduct() {
//   try {
//     // 1. Obtener carrito actual
//     let currentCart = await fetch("/cart.json");
//     currentCart = await currentCart.json();

//     // 2. Verificar si el producto gratis ya está en el carrito
//     const freeProductInCart = currentCart.items.some(
//       item => item.id === this.VARIANT_PRODUCT_ID || item.variant_id === this.VARIANT_PRODUCT_ID
//     );

//     if (freeProductInCart) {
//       console.log("⚠️ El producto gratis ya está en el carrito.");
//       return; // Terminar ejecución
//     }

//     // 3. Buscar productos con tag "MEN" en el carrito
//     let hasMenProduct = false;
//     for (const item of currentCart.items) {
//       try {
//         const productResponse = await fetch(`/products/${item.handle}.json`);
//         if (!productResponse.ok) continue;

//         const productData = await productResponse.json();
//         const tags = productData.product?.tags || '';

//         if (typeof tags === 'string' && tags.split(', ').includes('MEN')) {
//           hasMenProduct = true;
//           break; // Encontró un producto "MEN"
//         }
//       } catch (error) {
//         console.error(`Error al verificar ${item.handle}:`, error);
//       }
//     }

//     // 4. Agregar producto gratis si hay "MEN"
//     if (hasMenProduct) {
//       const formData = {
//         items: [{
//           id: this.VARIANT_PRODUCT_ID,
//           quantity: this.FREE_PRODUCT_QUANTITY
//         }],
//         sections: "cart-drawer,cart-icon-bubble"
//       };

//       const response = await fetch('/cart/add.js', {
//         method: 'POST',
//         headers: { 'Content-Type': 'application/json' },
//         body: JSON.stringify(formData)
//       });

//       const data = await response.json();
//       console.log('✅ Producto gratis agregado:', data);
//       this.renderContents(data); // Actualizar UI
//     } else {
//       console.log("🔍 No hay productos con tag 'MEN' en el carrito.");
//     }

//   } catch (error) {
//     console.error('Error en validateFreeProduct:', error);
//   }
// }

  async removeItemDrawer(updates){
    await fetch('/cart/change.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify( updates )
    })
    .then(response => {
      return response.json();
    }).then((data)=> {  
      this.renderContents(data);    
    })
    .catch((error) => {
      console.error('Error:', error);
    }).finally(()=> {
      console.log('Actualizado..');   
    });

  };


  async open(triggeredBy) {   
    this.validateFreeProduct();

    console.log('Abrí...');
    
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add('animate', 'active');    
    });

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = this.classList.contains('is-empty')
          ? this.querySelector('.drawer__inner-empty')
          : document.getElementById('CartDrawer');
        const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');    
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );

    document.body.classList.add('overflow-hidden');

  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {

    this.querySelector('.drawer__inner').classList.contains('is-empty') && this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;

    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);
      sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    });

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      this.open();    
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);
